define('app/views/tab_view_simple',['app/setup'], function(takhfifan) {

  takhfifan.simpleTabView = Backbone.View.extend({

    events: {
      'click .tab-view__list__item' : 'toggleTab'
    },

    initialize: function() {
      var _this = this;
    },

    toggleTab: function(e){
      e.preventDefault();
      var $current = $(e.currentTarget),
          target = $current.find('a').attr("href");

      this.$el.find('.tab-view__list__item').removeClass('active');
      this.$el.find('.tab-view__cnt').removeClass('active');

      $current.addClass('active');
      this.$el.find(target).addClass('active');
    }


  });
});

